import {UserRoles} from 'interfaces';

export const fullRoles = [
  UserRoles.member,
  UserRoles.therapist,
  UserRoles.prescriber,
];
export const providerRoles = [UserRoles.therapist, UserRoles.prescriber];
export const memberRoles = [UserRoles.member];
export const therapistRoles = [UserRoles.therapist];
export const prescriberRoles = [UserRoles.prescriber];
